/* ---------- step navigation ---------- */
function go(n){
  document.querySelectorAll('.fstep').forEach(e=>e.classList.remove('on'));
  document.getElementById('s'+n).classList.add('on');
  [1,2,3].forEach(i=>document.getElementById('b'+i).classList.toggle('on', i<=n));
  const box = document.querySelector('.finder-box');
  window.scrollTo({top: box.getBoundingClientRect().top + window.scrollY - 80, behavior:'smooth'});
}

/* ---------- step 1: type ---------- */
document.querySelectorAll('.type').forEach(b=>{
  b.addEventListener('click',()=>{
    document.querySelectorAll('.type').forEach(x=>x.setAttribute('aria-pressed','false'));
    b.setAttribute('aria-pressed','true');
    sel.type = b.dataset.type;

    // Sectionals need a third measurement; relabel the fields to match.
    const isSec = sel.type==='sectional';
    document.getElementById('chaiseWrap').classList.toggle('on', isSec);
    document.getElementById('wlabel').textContent = isSec ? '① Main run width' : '① Inner width';
    document.getElementById('whint').textContent  = isSec
      ? 'The longer arm of the L, inside face to inside face.'
      : 'Inside of one arm across to the inside of the other.';
    document.getElementById('dlabel').textContent = isSec ? '③ Seat depth' : '② Seat depth';

    setTimeout(()=>go(2), 130);
  });
});

/* ---------- cm helper ---------- */
function cmHint(el, note){
  el.addEventListener('input',()=>{
    const v = parseFloat(el.value);
    note.textContent = (v>0) ? '≈ ' + Math.round(v*2.54) + ' cm' : '';
  });
}
function cmSafe(a,b){const x=document.getElementById(a),y=document.getElementById(b); if(x&&y) cmHint(x,y);}
cmSafe('w','wcm');
cmSafe('d','dcm');
cmSafe('c','ccm');

/* ---------- validate + calculate ---------- */
const calcBtn=document.getElementById('calc');
if(calcBtn) calcBtn.addEventListener('click',()=>{
  const isSec = sel.type==='sectional';
  const wEl=document.getElementById('w'), dEl=document.getElementById('d'), cEl=document.getElementById('c');
  const wErr=document.getElementById('werr'), dErr=document.getElementById('derr'), cErr=document.getElementById('cerr');
  const w=parseFloat(wEl.value), d=parseFloat(dEl.value), c=parseFloat(cEl.value);
  let bad=false;

  [wErr,dErr,cErr].forEach(e=>e.classList.remove('on'));

  if(!w || w<10 || w>200){
    wErr.textContent = !w ? 'Please enter the width in inches.'
                          : 'That looks off — we’d expect something between 10 and 200 inches.';
    wErr.classList.add('on'); bad=true;
  }
  if(isSec && (!c || c<10 || c>120)){
    cErr.textContent = !c ? 'Sectionals need the chaise length too.'
                          : 'That looks off — we’d expect something between 10 and 120 inches.';
    cErr.classList.add('on'); bad=true;
  }
  if(!d || d<8 || d>60){
    dErr.textContent = !d ? 'Please enter the seat depth in inches.'
                          : 'That looks off — we’d expect something between 8 and 60 inches.';
    dErr.classList.add('on'); bad=true;
  }
  if(bad){
    const first = document.querySelector('.err.on');
    if(first) first.scrollIntoView({block:'center', behavior:'smooth'});
    return;
  }

  sel.w=w; sel.d=d; sel.c = isSec ? c : null;
  render(match(sel.type, w, d, sel.c));
  go(3);
});

const b1=document.getElementById('back1'); if(b1) b1.addEventListener('click',()=>go(1));
const b2=document.getElementById('back2'); if(b2) b2.addEventListener('click',()=>go(2));

/* ---------- "email me the guide" fallback ----------
   Wire the submit to Klaviyo / Shopify customer capture in the real build. */
const laterForm=document.getElementById('laterForm');
if(laterForm) laterForm.addEventListener('submit',e=>{
  e.preventDefault();
  const email = document.getElementById('laterEmail').value.trim();
  if(!email) return;
  document.querySelector('.later').classList.add('done');
  document.getElementById('laterOk').classList.add('on');
});

/* ---------- sticky mobile CTA ---------- */
const sticky=document.getElementById('sticky'), finder=document.getElementById('finder');
if(sticky && finder){
  new IntersectionObserver(es=>{
    es.forEach(e=>{ sticky.classList.toggle('on', !e.isIntersecting && window.scrollY>560); });
  },{threshold:0}).observe(finder);
}
